import React from "react"
import styled, { css } from "styled-components"
import { colors } from "buoy-theme"
import { Paragraph, FormField } from "buoy-core"
import { InputLabel, Required, FieldContainer } from "buoy-input"
import { responsive } from "../../../common/styledHelpers"
import { nDashPlaceholder } from "../userDetailsUtilities"
// 4851-todo: update responsive helper

export const FormRow = styled.div`
  display: flex;
  position: relative;
  align-items: ${props =>
    props.singleLabel
      ? props.isEditing ? "flex-end" : "flex-start"
      : "flex-start"};
  justify-content: space-between;
  ${props =>
    props.last
      ? css`
          margin-bottom: -24px;
        `
      : responsive("margin-bottom", "24px", "0")};
  ${responsive("flex-direction", "row", "column")};
  ${props =>
    props.last
      ? css`
          border-bottom: none;
        `
      : responsive("border-bottom", "solid 1px #d9d9d9", "none")};
`

export const FieldText = styled(Paragraph).attrs({ small: true })`
  margin: 0;
`

export const InputContainer = styled(FieldContainer)`
  ${responsive("margin-right", "12px", "0")};
  margin-bottom: 0;
  &:last-of-type {
    margin-right: 0px;
  }
  position: relative;
  ${props =>
    props.paddingBottom
      ? css`
          ${props.paddingBottom};
        `
      : ""};
`

export const Label = styled(InputLabel)`
  margin: 0 6px 0 0;
  color: ${colors.neutral};
`

export const LabelRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  height: 13px;
`

export const SelectRow = styled.div`
  display: flex;
  margin-top: 6px;
`

export const ErrorMessage = styled(Paragraph)`
  color: ${colors.error};
  font-size: 12px;
  line-height: 1;
  position: absolute;
  bottom: 0;
  margin: 4px 0 8px;
`

export const InputWithLabel = ({
  isEditing,
  edit,
  label,
  pattern,
  error,
  required,
  ...props
}) => (
  <InputContainer
    paddingBottom={
      isEditing
        ? "padding-bottom: 0"
        : responsive("padding-bottom", "0", "20px")
    }
  >
    <LabelRow>
      <Label>
        {label}
        {required && <Required />}
      </Label>
    </LabelRow>
    {isEditing ? (
      <FormField
        errorMessage={error}
        pattern={pattern}
        ariaLabel={label}
        placeholder={props.placeholder || label}
        {...props}
      />
    ) : (
      <FieldText small>{props.value || nDashPlaceholder}</FieldText>
    )}
  </InputContainer>
)



// WEBPACK FOOTER //
// ./assets/account/components/forms/common.js